export default __webpack_public_path__ + "static/media/CurrentPowerIcon.9650352b.svg";